import { safeCallback } from './func_arr';
const triggerRenderOnContext = (context, cb) => {
    context.render(() => {
        if (typeof cb === 'function') {
            safeCallback('render', cb, context, [null]);
        }
    });
};
export const triggerRender = (element, callback) => {
    const context = element.getBackendContext();
    if (context) {
        triggerRenderOnContext(context, callback || null);
    }
};
//# sourceMappingURL=render.js.map